<div class="pt-2">
  <table >
    @if (thermostatFeatureStatus?.mode) {
      <tr>
        <td class="speed p-2">{{ 'lang.mode' | translate }}</td>
        <td>{{ thermostatFeatureStatus?.mode | splitCamelCaseTitle}}</td>
      </tr>
    }

    @if (thermostatFeatureStatus?.heatSetPoint) {
      <tr>
        <td class="speed p-2">{{ 'lang.heat_set_point' | translate }}</td>
        <td>{{ thermostatFeatureStatus?.heatSetPoint }}&deg;</td>
      </tr>
    }

    @if (thermostatFeatureStatus?.chillSetPoint) {
      <tr>
        <td class="speed p-2">{{ 'lang.chill_set_point' | translate }}</td>
        <td>{{ thermostatFeatureStatus?.chillSetPoint }}&deg;</td>
      </tr>
    }
    @if (thermostatFeatureStatus?.autoSetPoint) {
      <tr>
        <td class="speed p-2">{{ 'lang.auto_set_point' | translate }}</td>
        <td>{{ thermostatFeatureStatus?.autoSetPoint }}</td>
      </tr>
    }
    @if (thermostatFeatureStatus?.currentWaterTemp && thermostatFeatureStatus?.currentWaterTemp!=='') {
      <tr>
        <td class="speed p-2">{{ 'lang.water_temp' | translate }}</td>
        <td> {{ thermostatFeatureStatus?.currentWaterTemp}}&deg;</td>
      </tr>
    }

    @if(thermostatFeatureStatus?.waterTemp && thermostatFeatureStatus?.waterTemp!=='') {
        <tr>
            <td class="speed p-2">{{ 'lang.water_temp' | translate }}</td>
            <td> {{ thermostatFeatureStatus?.waterTemp}}&deg;</td>
        </tr>
    }
    </table>

</div>